import { Voter } from "@activecollab/security";
import {
  hasCustomPermission,
  isClient,
  isFinancialManager,
  isMember,
  isOwner,
  isPowerUser,
  isVirtual,
  userTypes,
} from "~/utils/userHelper";

export class UserVoter extends Voter {
  attributes = [
    "edit-profile",
    "change-password",
    "change-permissions",
    "invite-to-projects",
    "change-rates-and-capacity",
    "archive-user",
    "remove-user",
    "see-user-history",
    "invite-user",
    "edit-virtual-user",
  ];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }

    return subject && userTypes.includes(subject.class);
  }

  voteOnAttribute(attribute, subject, user) {
    const isUserPrivileged = isPowerUser(user) || isFinancialManager(user);
    const isSubjectUnprivileged = !isPowerUser(subject) && !isFinancialManager(subject);
    const voteForChangePasswordAndEditProfile = () => {
      if (subject.is_archived) {
        return false;
      }

      if (subject.id === user.id) {
        return true;
      }

      if (isOwner(subject) && isOwner(user) && subject.is_pending_activation) {
        return true;
      }

      if (
        isMember(subject) &&
        (isOwner(user) ||
          (isFinancialManager(user) && isSubjectUnprivileged) ||
          (subject.created_by_id === user.id && isUserPrivileged)) &&
        subject.is_pending_activation
      ) {
        return true;
      }

      return isClient(subject) && (isFinancialManager(user) || (subject.created_by_id === user.id && isUserPrivileged));
    };

    const isMemberWithElevatedRoleOverSubject = isUserPrivileged && isSubjectUnprivileged;

    switch (attribute) {
      case "change-password":
        return !isVirtual(subject) && voteForChangePasswordAndEditProfile();
      case "edit-profile":
        return voteForChangePasswordAndEditProfile();
      case "edit-virtual-user": {
        if (isOwner(user)) {
          return true;
        }

        return !!isMemberWithElevatedRoleOverSubject;
      }
      case "change-permissions":
        return (isOwner(user) || isMemberWithElevatedRoleOverSubject) && subject.id !== user.id && !subject.is_archived;
      case "invite-to-projects":
        return (
          (isOwner(user) ||
            (isMember(user) &&
              (hasCustomPermission(user, "can_manage_projects") || hasCustomPermission(user, "can_manage_finances")) &&
              subject.id !== user.id)) &&
          !subject.is_archived
        );
      case "change-rates-and-capacity":
        return isFinancialManager(user) && !isClient(subject) && !subject.is_archived;
      case "archive-user":
      case "remove-user":
        return (isOwner(user) || isMemberWithElevatedRoleOverSubject) && subject.id !== user.id;
      case "see-user-history":
        return isFinancialManager(user);
      case "invite-user":
        return isVirtual(subject) && (isOwner(user) || isMemberWithElevatedRoleOverSubject);
    }

    throw new Error("This code should not be reached!");
  }
}
